module.exports = __webpack_public_path__ + "static/media/8-trygt.01089b4c.mp3";